import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { AsyncForPaintSidebarFiltersGlobal } from '@atlassian/jira-navigation-apps-sidebar-filters/src/async.tsx';

export const getCommonGlobalNavigation = () => ({
	menuId: MENU_ID.FILTERS,
	sidebar: AsyncForPaintSidebarFiltersGlobal,
});
